import { BinanceWallet, Metamask, SafePalWallet, TrustWallet, WalletConnect } from '../components/common/asset/icons';

export const NetworkContextName = 'NETWORK';
export const API_KDG = 'https://hub.hubecom.com/api'

// wallet list
export const WALLET_LIST = [
  { icon: Metamask, title: 'Metamask', connectorId: 'injected' },
  { icon: BinanceWallet, title: 'Binance Wallet', connectorId: 'bsc' },
  { icon: SafePalWallet, title: 'SalePal Wallet', connectorId: 'injected' },
  { icon: WalletConnect, title: 'Wallet Connect', connectorId: 'walletconnect' },
  { icon: TrustWallet, title: 'Trust Wallet', connectorId: 'injected' }
]

export const NEED_A_PLACEHOLDER = WALLET_LIST.length % 2 !== 0;
export const ADDRESS_BUSD_ADDRESS = '0xe9e7cea3dedca5984780bafc599bd69add087d56';
export const MAINNET_BSC_URL = 'https://bsc-dataseed.binance.org';
export const MAINNET_CHAIN_ID = 56;

export const bscTokens = [
  // stake pool
  {
    id: 'wbnb',
    symbol: 'wbnb',
    contract: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  },
  {
    id: 'binance-usd',
    symbol: 'busd',
    contract: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  },
  {
    id: 'tether',
    symbol: 'USDT',
    contract: '0x55d398326f99059fF775485246999027B3197955',
  },
  {
    id: 'ethereum',
    symbol: 'ETH',
    contract: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
  },
  {
    id: 'dai',
    symbol: 'DAI',
    contract: '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
  },
  {
    id: 'polis',
    symbol: 'POLIS',
    contract: '0xb5bea8a26d587cf665f2d78f077cca3c7f6341bd',
  },
  {
    id: 'tether',
    symbol: 'USDT',
    contract: '0x049d68029688eAbF473097a2fC38ef61633A3C7A',
  },
  {
    id: 'usd-coin',
    symbol: 'USDC',
    contract: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
  },
  {
    id: 'bsc-station',
    symbol: 'BSCS',
    contract: '0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d',
  },
  {
    id: 'kingdom-game-4-0',
    symbol: 'KDG',
    contract: '0x87a2d9a9a6b2d61b2a57798f1b4b2ddd19458fb6',
  },


]

export const ADDRESS_RECEVIE_BUSD = '0x9a5D956C9FBc8Bd51a08DFC31441A2cCff2584aE'
export const API_LAUNCHPAD = 'http://125.212.214.195:8112/api/'
export const CONTRACT_JOIN_POOL = '0x3A245F0a31226bDCa89B8afbb1F5052768d1d3eB'

// MAINNET NETWORK
export const MAPPING_CHAINID = {
  bsc: '0x38',
  eth: '0x1',
  poly: '0x89',
  ftom: '0xFA',
  arb: '0xa4b1',
  arbtestnet: '0x66EED',
  base: '0x2105',
  avax: '0xa86a',
  kaia: '0x2019',
}
export const CHAIN_INFO = {
  bsc: {
    decimal: 'ether',
    token: {
      id: 'wbnb',
      symbol: 'BNB',
      contract: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    },
    stableToken: {
      id: 'binance-usd',
      symbol: 'busd',
      contract: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
    }
  },
  eth: {
    decimal: 'picoether',
    token: {
      id: 'ethereum',
      symbol: 'ETH',
      contract: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    },
    stableToken: {
      id: 'tether',
      symbol: 'USDT',
      contract: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    }
  },
  poly: {
    decimal: 'picoether',
    token: {
      id: 'polygon',
      symbol: 'MATIC',
      contract: '',
    },
    stableToken: {
      id: 'usd-coin',
      symbol: 'USDC',
      contract: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    }
  },
  ftom: {},
  arb: {
    decimal: 'ether',
    token: {
      id: 'ethereum',
      symbol: 'ETH',
      contract: '',
    },
    stableToken: {
      id: 'tether',
      symbol: 'USDT',
      contract: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
    }
  },
  base: {
    decimal: 'picoether',
    token: {
      id: 'ethereum',
      symbol: 'ETH',
      contract: '',
    },
    stableToken: {
      id: 'usdc',
      symbol: 'USDC',
      contract: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    }
  },
  avax: {
    decimal: 'picoether',
    token: {
      id: 'avax',
      symbol: 'AVAX',
      contract: '',
    },
    stableToken: {
      id: 'usdc',
      symbol: 'USDC',
      contract: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    }
  },
  kaia: {
    decimal: 'picoether',
    token: {
      id: 'kaia',
      symbol: 'KAIA',
      contract: '',
    },
    stableToken: {
      id: 'usdt',
      symbol: 'USDT',
      contract: '0xcee8faf64bb97a73bb51e115aa89c17ffa8dd167',
    }
  }
}
export const CHAIN_STABLECOIN = {
  busd: ""
}
export const MAPPING_CHAINID_DECIMAL = {
  bsc: 56,
  eth: 1,
  poly: 137,
  ftom: 250,
  arb: 42161,
  arbtestnet: 421613,
  base: 8453,
  avax: 43114,
  kaia: 8217,
}
export const CHAINID_CONVERT = {
  56: 'bep',
  1: 'eth',
  138: 'poly',
  250: 'ftom',
  42161: 'arb',
  421613: "arbtestnet",
  8453: "base",
  43114: "avax",
  8217: "kaia",
};

export const CHAINID_FULLNAME = {
  bsc: 'BSC',
  eth: 'Ethereum',
  poly: 'Polygon',
  ftom: 'Phantom',
  arb: 'Arbitrum',
  solana: 'Solana',
  arbtestnet: "ArbitrumTest",
  base: "Base",
  avax: "Avalanche C-Chain",
  kaia: "Kaia",
};

export const CHAINID_LOGO = {
  bsc: '../images/icon-binance.svg',
  eth: '../images/icon-ethereum.svg',
  poly: '../images/icon-polygon.svg',
  arb: '../images/arb.png',
  solana: '../images/solana.png',
  base: '../images/base-1.png',
  ftom: '',
  avax: '../images/avax.png',
  kaia: '../images/kaia.png'
};

export const ADDRESS_USD = {
  56: {
    BUSD: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    USDT: '0x55d398326f99059fF775485246999027B3197955',
    USDC: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d'
  },
  1: {
    USDT: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    USDC: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
  },
  137: {
    USDC: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174'
  },
  42161: {
    USDT: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
    USDC: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8'
  },
  421613: {
    USDT: '0x5AB32546ca32442De752987Af6C08cFe1EF29A14',// token test
    USDC: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8'
  },
  250: '0xAd84341756Bf337f5a0164515b1f6F993D194E1f',
  8453: {
    USDC: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913'
  },
  43114: {
    USDC: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    USDT: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7'
  },
  8217: {
    USDT: '0xcee8faf64bb97a73bb51e115aa89c17ffa8dd167',
    USDC: '0xcee8faf64bb97a73bb51e115aa89c17ffa8dd167'
  }
}

export const IDO_CLAIM_TYPE_MONTHLY = 'MONTHLY';
export const IDO_CLAIM_TYPE_DAILY = 'DAILY';

export const CAMPAIGN_STATUS = {
  COMPLETED: 'COMPLETED',
  UPCOMING: 'UPCOMING',
  OPENING: 'OPENING',
  TBA: 'TBA',
}
export const ROUND_TYPE = {
  COMMUNITY: 1,
  GUARANTEED: 2,
  PRIVATE: 3,
  MVKB: 4
}
export const Tokens = {
  AUTHUSER: 'authUser',
};

export const LOCAL_STORAGE = {
  SIGNATURE_COMMIT: 'SCM',
};

export const Networks = {
  BSC: 'BSC',
  POLY: 'POLY',
  ETH: 'ETH',
  ARB: 'ARB',
  SOLANA: 'SOL',
  ARBTESTNET: "ARBTESTNET",
  BASE: 'BASE',
  AVAX: 'AVAX',
  KAIA: 'KAIA'
};

export const CHAIN_INFO_DECIMALS = {
  bsc: 'ether',
  eth: 'picoether',
  poly: 'picoether',
}